import { HelmetDexteel } from "@dexteel/mesf-core";
import { BilletsProcessDataReport } from "./components/BilletsProcessDataReport";

export const BilletsProcessDataPage = () => {
	return (
		<>
			<HelmetDexteel title="Billet Process Data" />
			<BilletsProcessDataReport />
		</>
	);
};
